// extracted by mini-css-extract-plugin
export var category = "_j8-9";
export var categoryHeader = "_j8-e";
export var container = "_j8-0";
export var group = "_j8-a";
export var groupItems = "_j8-f";
export var groupSeparator = "_j8-j";
export var loading = "_j8-1";
export var noResults = "_j8-3";
export var placeholder = "_j8-2";
export var resultContent = "_j8-5";
export var resultIcon = "_j8-c";
export var resultItem = "_j8-g";
export var resultMeta = "_j8-8";
export var resultSubtitle = "_j8-7";
export var resultSuffix = "_j8-i";
export var resultTitle = "_j8-6";
export var resultsList = "_j8-4";
export var searchGroup = "_j8-d";
export var selected = "_j8-h";
export var subgroup = "_j8-b";